import React from 'react';
import { Box, Container } from '@mui/material';
import FadeIn from 'react-fade-in';
import { useTranslation } from 'react-i18next';
import Page from 'src/components/Page';
import AutomaticDebitCollectionListTabs from './automaticDebitCollectionView/AutomaticDebitCollectionListTabs';
import useStyles from './styles';
import Toolbar from './automaticDebitCollectionView/Toolbar';

const AutomaticDebitCollectionsView = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Page
      className={classes.ContainerRoot}
      title={t('NAVIGATION.AUTOMATIC_DEBIT_COLLECTIONS')}
    >
      <FadeIn transitionDuration={200}>
        <Container maxWidth={false}>
          <Toolbar />
          <Box mt={3}>
            <AutomaticDebitCollectionListTabs />
          </Box>
        </Container>
      </FadeIn>
    </Page>
  );
};

export default AutomaticDebitCollectionsView;
